export const getCacheKey = ({ url, httpMethod }) => `${url}|${httpMethod}`;
